import Axios from '@/assets/js/AxiosPlugin'

// 查找/获取实体卡绑定信息
export const memberSearchCardList = params => { return Axios.post('/api/Admin/Member/searchCardList', params) }

// 绑定实体卡
export const memberAddCard = params => { return Axios.post('/api/Admin/Member/addCard', params) }

// 实体卡信息（惠州）
export const searchList = params => { return Axios.post('/api/Admin/Physicalcard/searchList', params) }

// 扣款
export const physicalcardSpend = params => { return Axios.post('/api/Admin/Physicalcard/spend', params) }

// 扣款
export const recordsList = params => { return Axios.post('/api/Admin/Physicalcard/records', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CardManagementApp/apis/index.js